var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "56.6934px",
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 56.6934 56.6934"
    },
    viewBox: "0 0 56.6934 56.6934",
    width: "56.6934px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.332,18.0622L12.6744,3.7905C11.2891,3.0489,9.787,3.011,8.4869,3.485l22.7111,22.7111L39.332,18.0622z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2731,23.3844l-7.6787-4.1109l-8.6595,8.6594l8.6595,8.6595l7.6786-4.111   C52.9054,30.5368,52.9054,25.329,49.2731,23.3844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4077,4.8794C5.5932,5.7746,5.0798,6.9697,5.0798,8.339v39.1878c0,1.3693,0.5134,2.5645,1.3278,3.4597l23.0536-23.0536   L6.4077,4.8794z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4869,52.3809c1.3,0.4739,2.8022,0.4362,4.1875-0.3055L39.332,37.8037l-8.1339-8.1339L8.4869,52.3809z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGooglePlay);
export default __webpack_public_path__ + "static/media/ic_google_play.e1e31ac7.svg";
export { ForwardRef as ReactComponent };